module.exports = __webpack_public_path__ + "static/ClickedPermanentlyDisabled-4d045591589e3d00091df1b365fa9a82.png";